import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button, Alert } from 'react-bootstrap';
import { 
    deleteSparepartExpense, 
    setDeleteSparepartExpenseId 
} from '../../../actions/sparepart_expense';

const SparepartExpenseDeleteForm = () => {
    const dispatch = useDispatch();
    
    const { 
        delete_expense, 
        loading, 
        error,
        expenses,
        currentPage
    } = useSelector(state => state.sparepart_expense);

    // Use the expense object directly from state
    const expenseToDelete = delete_expense;

    const handleClose = () => {
        dispatch(setDeleteSparepartExpenseId(null));
    };

    const handleDelete = async () => {
        const success = await dispatch(deleteSparepartExpense(expenseToDelete?.id, currentPage));
        if (success) {
            handleClose();
        }
    };

    return (
        <Modal show={!!delete_expense} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title className="text-danger">Sarfni O'chirish</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {error && (
                    <Alert variant="danger">
                        {error.message || 'Xatolik yuz berdi'}
                    </Alert>
                )}

                {expenseToDelete && (
                    <div>
                        <p className="mb-3">
                            Quyidagi sarfni o'chirishni tasdiqlaysizmi?
                        </p>
                        
                        <div className="border rounded p-3 bg-light">
                            <div className="row">
                                <div className="col-sm-4">
                                    <strong>Ehtiyot qism:</strong>
                                </div>
                                <div className="col-sm-8">
                                    {expenseToDelete.spare_part?.name}
                                </div>
                            </div>
                            
                            <div className="row mt-2">
                                <div className="col-sm-4">
                                    <strong>Miqdor:</strong>
                                </div>
                                <div className="col-sm-8">
                                    <span className="text-danger fw-bold">-{expenseToDelete.quantity}</span>
                                </div>
                            </div>
                            
                            <div className="row mt-2">
                                <div className="col-sm-4">
                                    <strong>Narx:</strong>
                                </div>
                                <div className="col-sm-8">
                                    <span className="text-success fw-bold">
                                        {expenseToDelete.unit_price ? 
                                            `${parseFloat(expenseToDelete.unit_price).toLocaleString('en-US')} so'm` : 
                                            '-'
                                        }
                                    </span>
                                </div>
                            </div>
                            
                            <div className="row mt-2">
                                <div className="col-sm-4">
                                    <strong>Ombor:</strong>
                                </div>
                                <div className="col-sm-8">
                                    {expenseToDelete.warehouse?.name}
                                </div>
                            </div>
                            

                            
                            <div className="row mt-2">
                                <div className="col-sm-4">
                                    <strong>Sarflagan shaxs:</strong>
                                </div>
                                <div className="col-sm-8">
                                    {expenseToDelete.consumed_by_user?.name}
                                </div>
                            </div>
                            
                            <div className="row mt-2">
                                <div className="col-sm-4">
                                    <strong>Sana:</strong>
                                </div>
                                <div className="col-sm-8">
                                    {expenseToDelete.date}
                                </div>
                            </div>



                            {expenseToDelete.description && (
                                <div className="row mt-2">
                                    <div className="col-sm-4">
                                        <strong>Qo'shimcha ma'lumot:</strong>
                                    </div>
                                    <div className="col-sm-8">
                                        {expenseToDelete.description}
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="alert alert-warning mt-3 mb-0">
                            <small>
                                <strong>Diqqat:</strong> Bu amal qaytarib bo'lmaydi. Sarf ma'lumotlari butunlay o'chiriladi.
                            </small>
                        </div>
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Bekor qilish
                </Button>
                <Button 
                    variant="danger" 
                    onClick={handleDelete}
                    disabled={loading}
                >
                    {loading ? 'O\'chirilmoqda...' : 'Ha, o\'chirish'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SparepartExpenseDeleteForm; 